export enum Location {
  SPLIT = 'ST',
  ZAGREB = 'ZG',
}
